import { render, staticRenderFns } from "./CopyPromotion.vue?vue&type=template&id=3d1dd8a2&scoped=true"
import script from "./CopyPromotion.vue?vue&type=script&lang=js"
export * from "./CopyPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1dd8a2",
  null
  
)

export default component.exports